import {
  NAME_LIST_REQUEST,
  NAME_LIST_SUCCESS,
  NAME_LIST_FAIL,
  NAME_LIST_RESET,
  NAME_ADD_REQUEST,
  NAME_ADD_SUCCESS,
  NAME_ADD_FAIL,
  NAME_DELETE_REQUEST,
  NAME_DELETE_SUCCESS,
  NAME_DELETE_FAIL,
  NAME_ALL_REQUEST,
  NAME_ALL_SUCCESS,
  NAME_ALL_FAIL
} from '../constants/nameConstants'

export const nameListReducer = (state = { manufacturer: [] }, action) => {
  switch (action.type) {
    case NAME_LIST_REQUEST:
      return { loading: true, ...state }

    case NAME_LIST_SUCCESS:
      return {
        loading: false,
        error: false,
        manufacturer: action.payload.manufacturer,
        pagesname: action.payload.pages,
        pagename: action.payload.page,
        count: action.payload.count
      }

    case NAME_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const nameAllReducer = (state = { manufacturer: [] }, action) => {
  switch (action.type) {
    case NAME_ALL_REQUEST:
      return { loading: true, ...state }

    case NAME_ALL_SUCCESS:
      return {
        loading: false,
        error: false,
        manufacturer: action.payload.manufacturer
      }

    case NAME_ALL_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const nameAddReducer = (state = {}, action) => {
  switch (action.type) {
    case NAME_ADD_REQUEST:
      return { loading: true }
    case NAME_ADD_SUCCESS:
      return { loading: false, error: false, success: true }
    case NAME_ADD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const nameDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case NAME_DELETE_REQUEST:
      return { loading: true }
    case NAME_DELETE_SUCCESS:
      return { loading: false, error: false, success: true }
    case NAME_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const nameResetReducer = (state = {}, action) => {
  switch (action.type) {
    case NAME_LIST_RESET:
      return {}
    default:
      return state
  }
}
